import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { PropTypes as PT } from 'prop-types';
import { ReactComponent as SearchIcon } from '@lifesize/ux-assets/vectors/svgIcons/search.svg';
import PillComp from 'components/Pill/Pill';
import { ADD_PARTICIPANT_FORM } from 'constants/AddParticipantDrawer';
import classes from 'components/AddParticipantDrawer/Search/AddParticipantSearch.module.scss';

const messages = defineMessages({
  search: { id: 'components.addParticipant.search', defaultMessage: 'Type a name or number' }
});

class AddParticipantSearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.focus = this.focusHandler.bind(this);
    this.state = {
      placeholderText: props.intl.formatMessage(messages.search)
    };
  }

  onKeyDown = (e) => {
    if (e.which !== 13 || !this.props.searchString || this.props.searchContacts.length) return;
    const searchString = this.props.searchString;
    const manualContact = {
      name: searchString,
      id: searchString,
      dialString: searchString,
      isManual: true
    };
    this.props.handleSelectContact(manualContact);
  };

  focusHandler() {
    this.props.handleSetIsFocused(true);
  }

  inputField = (props) =>
    props.contact?.name ? (
      <div className={classes.selectedContactContainer}>
        <PillComp disabled={false} id={props.contact.id} onRemove={this.props.clearSelectedCall} value={props.contact}>
          <span className={classes.pillLabel}>{this.props.contact.name}</span>
        </PillComp>
      </div>
    ) : (
      <input
        {...props.input}
        autoComplete="off"
        autoFocus={this.state.autoFocus}
        className={classes.inputField}
        data-testid="addParticipant-search-input"
        maxLength={64}
        onFocus={this.focus}
        onKeyDown={this.onKeyDown}
        placeholder={this.state.placeholderText}
        type="text"
      />
    );

  render() {
    return (
      <div className={classes.searchContainer}>
        <SearchIcon />
        <Field
          component={this.inputField}
          contact={this.props.contact}
          focused={this.state.focused}
          id="addParticipantsSearch"
          name="addParticipantSearchBar"
        />
      </div>
    );
  }
}

AddParticipantSearchBar.propTypes = {
  clearSelectedCall: PT.func,
  contact: PT.object,
  handleSelectContact: PT.func,
  handleSetIsFocused: PT.func,
  intl: PT.object,
  searchContacts: PT.array,
  searchString: PT.string
};

export default reduxForm({
  form: ADD_PARTICIPANT_FORM,
  getFormState: (state) => state.app.form
})(injectIntl(AddParticipantSearchBar));
